<template>
  <div>
    <!--右侧内容-->
    <div class="class_add_top"><a class="back" @click="backQuestionList()">返回</a>添加考题</div>
    <div class="class_add_con">
      <table width="100%" border="0" cellspacing="0" cellpadding="0">
        <tr class="tita">
          <td class="left_td">考题信息</td>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td class="left_td pt30">标题：</td>
          <td class="pt20"><input type="text" v-model="params.title" class="put_495" style=" width:395px;"/></td>
        </tr>
        <tr>
          <td class="left_td pt30">试题类型：</td>
          <td class="pt20"><li class="sea_on">多选题</li></td>
        </tr>
        <tr>
          <td class="left_td pt30">所属分类：</td>
          <td class="pt20">
            <select name="select" v-model="params.largeType" class="all_select" @change="getMiddleTypes(params.largeType)">
              <option v-for='item in largeTypes' :key="item.value" :value="item.value">{{item.label}}</option>
            </select>
            <select name="select" v-model="params.middleType" class="all_select">
              <option v-for='item in middleTypes' :key="item.middleType" :value="item.middleType">{{item.middleTypeLabel}}</option>
            </select>
          </td>
        </tr>
        <tr>
          <td class="left_td"></td>
          <td>
            <p>没有合适的分类？您可以<router-link :to="{path: prefix + '/org/examQClassification_f/' + $utils.URLencode(this.$route.fullPath) + '/' + this.$route.params.id}" class="routerLink">添加新分类</router-link></p>
          </td>
        </tr>
        <tr>
          <td class="left_td pt30">难易度：</td>
          <td class="pt20">
            <select name="select" v-model="params.level" class="all_select">
              <option v-for='item in Dropdown.state.level' :key="item.value" :value="item.value">{{item.label}}</option>
            </select>
          </td>
        </tr>
        <tr>
          <td class="left_td pt20" valign="top">试题题干：</td>
          <td class="pt10"><textarea v-model="params.questionInfoText" name="" cols="" rows=""  class="text_area"></textarea></td>
        </tr>
        <tr>
          <td class="left_td pt20" valign="top">问题资源地址：</td>
          <td class="pt10"><UploadOSS :uploadOSSConf="uploadOSSConf" :DOM_ID="'questionInfoUrl'" v-if="uploadOSSConf.STS!=null"  @success = "OSSUploadSuccess"></UploadOSS><input id="questionUri" v-model="params.questionInfoUrl"  name="questionUri" class="put_495" type="text" style="width:230px; margin-left:10px;" value="" maxlength="255" readonly></td>
        </tr>
        <tr>
          <td class="left_td pt20" valign="top">选项设置：</td>
          <td class="pt10">
            <table width="780" border="0" cellspacing="0" cellpadding="0" class="add_kaoti_xuan">
              <tr>
                <th width="60">正确项</th>
                <th width="50">编号</th>
                <th width="20">分值</th>
                <th>描述</th>
                <th width="280">资源上传</th>
                <th width="60">操作</th>
              </tr>
              <tr v-for="item in options" :key="item.index">
                <td><input name="checkoptions" type="checkbox" :checked="item.checked=='1'" :value="item.index" @click="changeOptionAnswer(item.index, 'checkbox', options)"/></td>
                <td>{{String.fromCharCode(65 + parseInt(item.index))}}</td>
                <td><input v-model="item.score" type="text" class="put_495" style="width: 50px"></td>
                <td><textarea v-model="item.text" name="" cols="" rows=""  class="text_area22"></textarea></td>
                <td>
                  <UploadOSS :uploadOSSConf="uploadOSSConf" :DOM_ID="'option_' + item.index"
                             v-if="uploadOSSConf.STS!=null" @success="OSSUploadSuccess"></UploadOSS>
                  <input id="questionUri2" v-model="params['option_' + item.index]" class="put_495" type="text"
                         style="width:100px; margin-left:10px;" value="" maxlength="255" readonly>
                </td>
                <td>
                  <a title="删除" class="el-icon-delete" @click="delOption(item.index)" style="cursor: pointer;"></a>
                </td>
              </tr>
            </table>
            <p><a href="javascript:;" @click="addOption()" class="add_bt_all">新增选项</a></p>
          </td>
        </tr>
        <tr>
          <td class="left_td pt20" valign="top">解题思路：</td>
          <td class="pt10"><textarea v-model="params.thinkingInfoText" name="" cols="" rows=""  class="text_area"></textarea></td>
        </tr>
        <tr>
          <td class="left_td pt20" valign="top">解题思路地址：</td>
          <td class="pt10"><UploadOSS :uploadOSSConf="uploadOSSConf" :DOM_ID="'thinkingInfoUrl'" v-if="uploadOSSConf.STS!=null"  @success = "OSSUploadSuccess"></UploadOSS><input id="questionUri6" v-model="params.thinkingInfoUrl" name="questionUri6" class="put_495" type="text" style="width:260px; margin-left:10px;" value="" maxlength="255" readonly></td>
        </tr>
        <tr>
          <td class="left_td pt20" valign="top">试题信息：</td>
          <td class="pt10"><textarea v-model="params.description" name="" cols="" rows=""  class="text_area"></textarea></td>
        </tr>
      </table>
      <p class="btn_center">
        <input name="" type="button" class="all_btn" @click="editQuestion()" value="保存提交" />
      </p>
    </div>
    <!--/右侧内容-->
  </div>
</template>
<script>

  import Dropdown from '@/store/modules/dropdowns'
  import UploadOSS from '@/components/common/upload/uploadOSS.vue'

  export default {
    components: { UploadOSS },
    data () {
      return {
        Dropdown: Dropdown,
        options: [
          {
            checked: '1',
            index: '0',
            text: '',
            url: ''
          },
          {
            checked: '0',
            index: '1',
            text: '',
            url: ''
          }
        ],
        pages: 0,
        params: {
          title: '',
          questionType: 'multiSelection',
          answerInfo: '',
          description: '',
          largeType: '',
          level: '',
          middleType: '',
          questionInfo: '',
          thinkingInfo: '',
          questionInfoText: '',
          questionInfoUrl: '',
          thinkingInfoText: '',
          thinkingInfoUrl: ''
        },
        answerInfoArr: [],
        largeTypes: [],
        middleTypes: [],
        prefix: this.$route.meta.prefix || '',
        uploadOSSConf: { showMode: '2', style: 'img_upload', typeArr: 'image/png,image/jpg,image/jpeg', catalog: 'byl', fileName: '', maxSize: '2000000', STS: null }
      }
    },
    created () {
      if (this.$route.params.id === 'create') {
        this.params = {
          title: '',
          questionType: 'multiSelection',
          answerInfo: '',
          description: '',
          largeType: '',
          level: '',
          middleType: '',
          questionInfo: '',
          thinkingInfo: '',
          questionInfoText: '',
          questionInfoUrl: '',
          thinkingInfoText: '',
          thinkingInfoUrl: ''
        }
      } else {
        this.getQuestion(this.$route.params.id)
      }
      this.getLargeTypes()
    },
    mounted () {
      this.$nextTick(() => {})
      this.getSTS()
    },
    computed: {},
    methods: {
      OSSUploadSuccess (r) {
        if (r && r != '') {
          this.$set(this.params, r.dom_id, r.res.requestUrls[0])
        }
        this.dealOptionsUrl(r, this.options)
      },
      changeOptionAnswer (index, type, arr) {
        if (type==='radio') {
          for (let i = 0; i<arr.length; i++) {
            arr[i].checked = '0'
          }
          arr[parseInt(index)].checked = '1'
        } else if (type==='checkbox') {
          if (arr[parseInt(index)].checked == '1') {
            arr[parseInt(index)].checked = '0'
          } else {
            arr[parseInt(index)].checked = '1'
          }
        }
      },
      dealOptionsUrl (result, optionArr) {
        if (result.dom_id.indexOf('option_')>=0) {
          let curOptionIndex = result.dom_id.split('_')[1]
          if (optionArr && optionArr.length>0) {
            optionArr[curOptionIndex].url = result.res.requestUrls[0]
          }
        }
      },
      dealOptionUrl_edit (optionArr) {
        for (let i=0; i<optionArr.length; i++) {
          this.params['option_'+optionArr[i].index] = optionArr[i].url
        }
      },
      addOption () {
        let temp = {
          checked: '0',
          index: this.options.length,
          text: '',
          url: ''
        }
        this.options.push(temp)
      },
      delOption(index) {
        let optionsLength = this.options.length;
        if (index == optionsLength - 1) {
          this.options.splice(index, 1);
        } else {
          this.$toasted.show('必须从最后一个选项删除！', {
            duration: 1000
          })
        }
      },
      getLargeTypes () {
        this.$api.post(this.$global.examApiPath, '/dict/get', {type: 'examLargeType'}, r => {
          this.largeTypes = r.data
        })
      },
      getMiddleTypes (largeType) {
        this.$api.post(this.$global.examApiPath, '/examTypeRel/search', {largeType: largeType,  middleType: 'examMiddleType', select: '1'}, r => {
          this.middleTypes = r.data
        })
      },
      getQuestion (id) {
        this.options = []
        this.$api.post(this.$global.examApiPath, '/examQuestion/get', {id: id}, r => {
          this.params = r.data
          this.$set(this.params, 'questionInfoText', this.$utils.dealQInfoNull(this.params.questionInfoList.description))
          this.$set(this.params, 'questionInfoUrl', this.$utils.dealQInfoNull(this.params.questionInfoList.uri))
          this.$set(this.params, 'thinkingInfoText', this.$utils.dealQInfoNull(this.params.thinkingInfoList.description))
          this.$set(this.params, 'thinkingInfoUrl', this.$utils.dealQInfoNull(this.params.thinkingInfoList.uri))
          this.getMiddleTypes(this.params.largeType)
          for (let i=0; i<this.params.answerInfoList.length; i++) {
            let singleAnswer = this.params.answerInfoList[i]
            let temp = {
              checked: singleAnswer.isCorrect,
              index: singleAnswer.no,
              text: singleAnswer.description,
              url: singleAnswer.uri
            }
            temp.text = (temp.text=='' || temp.text=='undefined') ? '' : temp.text
            temp.url = (temp.url=='' || temp.url=='undefined') ? '' : temp.url
            this.options.push(temp)
          }
          this.dealOptionUrl_edit(this.options)
        })
      },
      editQuestion () {
        this.params.answerInfo = ''
        this.params.questionInfo = this.params.questionInfoText + '|' + this.params.questionInfoUrl
        this.params.thinkingInfo = this.params.thinkingInfoText + '|' + this.params.thinkingInfoUrl
        for (let i = 0; i<this.options.length; i++) {
          let temp = this.options[i].checked + '|' +this.options[i].index + '|' + this.options[i].text.replace(',', '，') + '|' + this.options[i].url
          if (i < this.options.length-1) {
            this.params.answerInfo += temp + ',';
          } else if (i == this.options.length-1) {
            this.params.answerInfo += temp;
          }
        }
        this.$api.post(this.$global.examApiPath, '/examQuestion/save', this.params, r => {
          if (this.$route.params.id == 'create') {
            this.$toasted.show('试题创建成功！', {
              duration: 1000
            })
            this.$router.push({path: this.prefix + '/org/examQuestionList'})
          } else {
            this.$toasted.show('试题修改成功！', {
              duration: 1000
            })
          }
          this.$router.push({path: this.prefix + '/org/examQuestionList'})
        })
      },
      backQuestionList() {
        this.$router.push({path: this.prefix + '/org/examQuestionList'})
      },
      getSTS () {
        this.$api.get(this.$global.resourceApiPath, '/common/getSTS', {}, r => {
          let STS = [r.data.expiration, r.data.accessKeyId, r.data.accessKeySecret, r.data.securityToken, r.data.endpointClean, r.data.bucket, r.data.region]
          this.uploadOSSConf.STS = STS
        })
      }
    }
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/byl/org/examination_question/model_multipleChoice.vue